if (!customElements.get('kik-care-tabs')) {
  class KikCareTabs extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._tabs = Array.from(this.querySelectorAll('.kik-care-tabs__tab'));
      this._panels = Array.from(this.querySelectorAll('.kik-care-tabs__panel'));

      if (!this._tabs.length) return;

      for (const tab of this._tabs) {
        tab.addEventListener('click', () => {
          this._activate(parseInt(tab.dataset.tabIndex, 10));
        });
      }
    }

    disconnectedCallback() {
      this._initialized = false;
    }

    _activate(index) {
      for (let i = 0; i < this._tabs.length; i++) {
        const active = i === index;
        this._tabs[i].classList.toggle('is-active', active);
        this._tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
        this._panels[i].classList.toggle('is-hidden', !active);
      }
    }
  }

  customElements.define('kik-care-tabs', KikCareTabs);
}
